import ApiClient from "../api/apiClient";

const ORGANIZATION_LIST = "/organizations";
const ORGANIZATION_NAME_LIST = "/organizations/search-organization";
const EXCEL_SHEET_DATA = "/bulk-registration/bulk-user-upload";

const getOrganizationsList = ({ page, limit }) => {
    const baseUrl = `${ORGANIZATION_LIST}?`;
    let queryParams = "";
    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};

const createOrganization = (data) => {
    return ApiClient.post(ORGANIZATION_LIST, data);
};

const getOrganisationById = (id) => {
    return ApiClient.get(ORGANIZATION_LIST + "/" + id);
};

const updateOrganizationById = (id, data) => {
    const baseUrl = `${ORGANIZATION_LIST}/`;
    let queryParams = "";
    // Add mandatory parameters
    queryParams += id;
    const url = baseUrl + queryParams;
    return ApiClient.put(url, data);
};

const getOrganizationNameList = (page, search) => {
    let url;
    if (page && search) {
        url = ApiClient.get(`${ORGANIZATION_NAME_LIST}?page=${1}&limit=${10}&search=${search}`);
    } else {
        url = ApiClient.get(`${ORGANIZATION_NAME_LIST}?page=${1}&limit=${10}`);
    }
    return url;
};

const getExcelSheetData = ({ page, limit }) => {
    const baseUrl = `${EXCEL_SHEET_DATA}?`;
    let queryParams = "";
    queryParams += `page=${page}&limit=${limit}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};
export const organiztionService = {
    getOrganizationsList,
    createOrganization,
    getOrganisationById,
    updateOrganizationById,
    getOrganizationNameList,
    getExcelSheetData,
};
